import { defineComponent as _defineComponent } from 'vue'
import TLinkButton from '~/components/atoms/t-link-button.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewsLink',
  setup(__props) {


return { __sfc: true,TLinkButton }
}

})